import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;

// «? Ajuda»: abre o WhatsApp do suporte (definido em /admin) com «Ajuda no processo #456».
export function HelpButton({ num }) {
  const [wa, setWa] = useState(cached);
  useEffect(() => {
    if (cached !== null) { return; }
    api.get("/public/legal").then(({ data }) => { cached = data.company?.suporte_whatsapp || ""; setWa(cached); }).catch(() => {});
  }, []);
  if (!wa) return null;
  const text = encodeURIComponent(`Ajuda no processo ${num}`);
  return (
    <a href={`https://wa.me/${wa}?text=${text}`} target="_blank" rel="noreferrer" data-testid="help-btn"
      className="ml-auto inline-flex items-center h-9 px-3.5 rounded-full border border-slate-300 bg-white text-sm font-semibold text-slate-800 hover:bg-slate-50 transition-colors">
      ? Ajuda
    </a>
  );
}
